import { defineMessages } from 'react-intl';

export default defineMessages({
  presoldLabel: {
    id: 'advancedChart.presold',
    description: 'Presold Customer Order',
    defaultMessage: 'Presold Customer Order',
  },
  stockLabel: {
    id: 'advancedChart.stock',
    description: 'Stock Order',
    defaultMessage: 'Stock Order',
  },
  currency: {
    id: 'currency',
    description: 'USD',
    defaultMessage: 'USD',
  },
  clearFiltersLabel: {
    id: 'clearFilters',
    description: 'Clear Filters',
    defaultMessage: 'Clear Filters',
  },
});
